import Cookies from 'js-cookie';
import originalFetch from 'isomorphic-fetch';
import fetchRetry from 'fetch-retry';
import GlobalRequestService from '@Helpers/URLHelpers/GlobalRequestService';

const apiClient = new GlobalRequestService(window.location.origin);

const unsafeMethods = ['POST', 'PUT', 'PATCH', 'DELETE'];

async function wrappedFetch(url, options = {}) {

    const controller = new AbortController();
    apiClient.activeControllers.push(controller);

    options.method = (options.method || 'GET').toUpperCase();
    options.headers = { ...(options.headers || {}), 'Content-Type': 'application/json' };

    if (unsafeMethods.includes(options.method)) {
        const csrfToken = Cookies.get('XSRF-TOKEN');
        if (csrfToken) {
            options.headers['X-XSRF-TOKEN'] = csrfToken
        };
    }

    let response = await originalFetch(url, { ...options, signal: controller.signal });

    if (response.status === 403 && unsafeMethods.includes(options.method)) {
        const newToken = Cookies.get('XSRF-TOKEN');
        if (newToken) {
            options.headers['X-XSRF-TOKEN'] = newToken
        };
        response = await originalFetch(url, { ...options, signal: controller.signal });
    }

    apiClient.activeControllers = apiClient.activeControllers.filter((c) => c !== controller);

    return response;
}

const retryingFetch = fetchRetry(wrappedFetch);

require.cache[require.resolve('isomorphic-fetch')].exports = retryingFetch;

export default apiClient;
